import type { IGetRequest } from "@/utils/async";
import { ERequestStatus, requestInit } from "@/utils/async";
import { createReducer } from "@reduxjs/toolkit";
import { IPromoActions } from "./promo-actions";

export interface IPromoModel {
  getSimpleDiscover: IGetRequest<any>;
  warnings: Record<string, boolean>;
}

const INITIAL_STATE: IPromoModel = {
  getSimpleDiscover: requestInit(),
  warnings: {},
};

/** Reducer */
export const promoReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(
      IPromoActions.initGetSimpleDiscover,
      (state, action): IPromoModel => {
        return {
          ...state,
          getSimpleDiscover: {
            status: ERequestStatus.Fetching,
          },
        };
      }
    )
    .addCase(
      IPromoActions.successGetSimpleDiscover,
      (state, action): IPromoModel => {
        return {
          ...state,
          getSimpleDiscover: {
            responseData: action.payload,
            status: ERequestStatus.Fetched,
          },
          warnings: action.payload,
        };
      }
    )
    .addCase(
      IPromoActions.failureGetSimpleDiscover,
      (state, action): IPromoModel => {
        return {
          ...state,
          getSimpleDiscover: {
            error: action.payload,
            status: ERequestStatus.Error,
          },
        };
      }
    );
});
